import { MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useScrollTo } from "@/lib/useScrollTo";

export const Footer = () => {
  const scrollTo = useScrollTo();
  return (
  <footer className="border-t border-[#2A2626] py-16">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2">
            <span className="font-display text-3xl tracking-tight">Przemiana</span>
            <span className="text-[#FF6B6B] font-display text-3xl">1:1</span>
          </div>
          <p className="text-muted mt-4 max-w-xs text-sm leading-relaxed">
            Personalne treningi dla kobiet 30+, które chcą schudnąć, poczuć się lepiej i odzyskać
            pewność siebie.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted mb-5">Lokalizacja</p>
          <div className="flex items-start gap-2 text-[#F5F2F0]">
            <MapPin className="w-5 h-5 text-[#FF6B6B] mt-0.5 shrink-0" />
            <span>
              Zdrofit Warszawa Stegny
              <span className="block text-muted mt-1">ul. Mangalia 4, Mokotów</span>
            </span>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted mb-5">Zaczynamy?</p>
          <button
            onClick={() => scrollTo("kontakt")}
            data-testid="footer-cta"
            className="btn-primary rounded-full px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.15em] flex items-center gap-2"
          >
            <Phone className="w-4 h-4" /> Umów trening
          </button>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-[#2A2626] flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-muted">
        <span>© {new Date().getFullYear()} Przemiana 1:1 · Zdrofit Stegny</span>
        <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-6">
          <Link
            to="/polityka-prywatnosci"
            data-testid="footer-privacy-link"
            className="hover:text-[#FF6B6B] transition-colors"
          >
            Polityka prywatności
          </Link>
          <span>Treningi personalne · Warszawa Mokotów</span>
        </div>
      </div>
    </div>
  </footer>
  );
};
